/** @format */

import {ResponsiveWidthImageThumbnail} from '../../../shared/responsive_width_image_thumbnail';
import DesignUploader from 'frontier/account/components/design_uploader/container';
import {Modal, ModalHeader} from '@sttark/design-system';
import {If} from 'frontier-utilities';
import React, {useState} from 'react';

import {ORDER_STATUS_WAITING_ON_CUSTOMER, ORDER_STATUS_NEEDS_ASSISTANCE} from 'frontier-constants';

// styles
import './design.scss';

export const Design = props => {
    const {order, design, designsOrders} = props;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const sumTotalDesignQty = designsOrders.reduce((sum, {qty}) => (sum += qty), 0);

    return (
        <div className="view-order-design-57kl">
            <div
                className="view-order-design-57kl__image"
                style={{
                    width:
                        design.design.customer_thumb_width > 240
                            ? 240
                            : design.design.customer_thumb_width
                }}>
                <ResponsiveWidthImageThumbnail
                    currentImgSource={design.pressready_thumb_signed_url ?? design.signed_url}
                    designOrder={design}
                />
                <p className="mt-2 mb-0 mx-0 p-0 view-order-design-57kl__filename">
                    {design.pressready_filename?.replace(props.design.id + '_', '') ??
                        design.filename_without_id}
                </p>
            </div>
        </div>
    );
};
